import { Link, useParams } from "react-router-dom";
import { globalCapDetailPages } from "./globalCapDetailData";
import GlobalCapDetailHero from "./globalCapDetailHero/GlobalCapDetailHero";
import GlobalCapDetailOverview from "./globalCapDetailOverview/GlobalCapDetailOverview";
import GlobalCapDetailOfferings from "./globalCapDetailOfferings/GlobalCapDetailOfferings";
import GlobalCapDetailProcess from "./globalCapDetailProcess/GlobalCapDetailProcess";
import GlobalCapDetailBenefits from "./globalCapDetailBenefits/GlobalCapDetailBenefits";
import GlobalCapDetailClosingCta from "./globalCapDetailClosingCta/GlobalCapDetailClosingCta";

function PageNotFound() {
  return (
    <div className="min-h-[60vh] bg-[var(--color-page)]">
      <section className="container section">
        <div className="max-w-3xl">
          <p className="text-eyebrow mb-4 text-[var(--color-brand)]">
            Error / 404
          </p>
          <h1 className="text-heading-1 text-[var(--color-ink)]">
            Page not found
          </h1>
          <p className="mt-5 max-w-2xl text-body-lg">
            The page you are looking for does not exist or may have moved.
          </p>
          <Link to="/global-capability" className="btn btn-primary mt-8">
            Back to Global Capability
          </Link>
        </div>
      </section>
    </div>
  );
}

export default function GlobalCapDetail() {
  const { slug } = useParams();

  const page = Object.prototype.hasOwnProperty.call(globalCapDetailPages, slug)
    ? globalCapDetailPages[slug]
    : null;

  if (!page) return <PageNotFound />;

  return (
    <>
      <GlobalCapDetailHero data={page.hero} />
      <GlobalCapDetailOverview data={page.overview} />
      <GlobalCapDetailOfferings data={page.offerings} />
      <GlobalCapDetailProcess data={page.process} />
      <GlobalCapDetailBenefits data={page.benefits} />
      <GlobalCapDetailClosingCta data={page.closing} />
    </>
  );
}
